module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-right-green-a54a86c4af5c11cbc67e2312d42f15b6.svg";